// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tablecellforemployeeRoster{
font-family: "Inter";
font-size: 14px;
font-weight: 700;
line-height: 17px;
letter-spacing: 0.02em;
text-align: left;
color: #0070E9; white-space: nowrap !important;

}
.EmployeeRoster{
    font-family: "Inter";
font-size: 18px;
font-weight: 600;
line-height: 22px;
letter-spacing: 0.02em;
text-align: left;
color:#0070E9

}
.mainFrame{
    background-color: white;
    height:600px;
}


.AddEmployerButton{
    width: 100%;
    max-width: 156px;
height:45px;
border-radius: 3px;
font-family: "Inter";
font-size: 16px !important;
font-weight: 600 !important;
line-height: 19px;
letter-spacing: 0.02em;
text-align: center;
background-color: #FE602F !important;
color:white !important;
text-transform: capitalize !important;


}

.jobType{
    font-family: "Inter";
font-size: 14px !important;
font-weight: 700 !important;
line-height: 17px !important;
letter-spacing: 0.02em;
text-align: left;

}

.TableCell{
    font-family: "Inter";
font-size: 15px !important;
font-weight: 400 !important;
line-height: 17px !important;
letter-spacing: 0.02em !important;
text-align: center;
color:#375370 !important;
height: 40px !important;
padding-top: 0px !important;
padding-bottom: 0px !important;

}

.TableCell2{
    font-family: "Inter";
font-size: 15px !important;
font-weight: 400 !important;
line-height: 17px !important;
letter-spacing: 0.02em !important;
text-align: center;
white-space: nowrap !important;
overflow: hidden !important;
text-overflow: ellipsis !important;
overflow: hidden !important;
  position: relative !important;
  color:#375370 !important;
}
.businessmail{
    overflow: hidden !important;
  position: relative !important;
  white-space: nowrap !important;
  text-overflow: ellipsis !important;
  display: inline-block !important; 
text-overflow: ellipsis !important;
/* width: calc(50%); */

}

@media only screen and (max-width: 1400px) {
    .employeeRosterMediaQuery {
      width: 73vw !important;
      /* border: 1px solid black !important; */
      justify-content: center;
      text-align: center;
      padding: 0.5vw;
    }
  }
  
  @media only screen and (min-width: 1400px) {
    .employeeRosterMediaQuery {
    min-width: 80vw !important;
    /* width: 20vw !important; */
    /* border: 1px solid black !important; */
    justify-content: center;
    text-align: center;
    padding: 0.5vw;
    }
  }`, "",{"version":3,"sources":["webpack://./src/views/panel/employeeRoster/EmployeeRoster.css"],"names":[],"mappings":"AAAA;AACA,oBAAoB;AACpB,eAAe;AACf,gBAAgB;AAChB,iBAAiB;AACjB,sBAAsB;AACtB,gBAAgB;AAChB,cAAc,EAAE,8BAA8B;;AAE9C;AACA;IACI,oBAAoB;AACxB,eAAe;AACf,gBAAgB;AAChB,iBAAiB;AACjB,sBAAsB;AACtB,gBAAgB;AAChB;;AAEA;AACA;IACI,uBAAuB;IACvB,YAAY;AAChB;;;AAGA;IACI,WAAW;IACX,gBAAgB;AACpB,WAAW;AACX,kBAAkB;AAClB,oBAAoB;AACpB,0BAA0B;AAC1B,2BAA2B;AAC3B,iBAAiB;AACjB,sBAAsB;AACtB,kBAAkB;AAClB,oCAAoC;AACpC,sBAAsB;AACtB,qCAAqC;;;AAGrC;;AAEA;IACI,oBAAoB;AACxB,0BAA0B;AAC1B,2BAA2B;AAC3B,4BAA4B;AAC5B,sBAAsB;AACtB,gBAAgB;;AAEhB;;AAEA;IACI,oBAAoB;AACxB,0BAA0B;AAC1B,2BAA2B;AAC3B,4BAA4B;AAC5B,iCAAiC;AACjC,kBAAkB;AAClB,wBAAwB;AACxB,uBAAuB;AACvB,2BAA2B;AAC3B,8BAA8B;;AAE9B;;AAEA;IACI,oBAAoB;AACxB,0BAA0B;AAC1B,2BAA2B;AAC3B,4BAA4B;AAC5B,iCAAiC;AACjC,kBAAkB;AAClB,8BAA8B;AAC9B,2BAA2B;AAC3B,kCAAkC;AAClC,2BAA2B;EACzB,6BAA6B;EAC7B,wBAAwB;AAC1B;AACA;IACI,2BAA2B;EAC7B,6BAA6B;EAC7B,8BAA8B;EAC9B,kCAAkC;EAClC,gCAAgC;AAClC,kCAAkC;AAClC,sBAAsB;;AAEtB;;AAEA;IACI;MACE,sBAAsB;MACtB,wCAAwC;MACxC,uBAAuB;MACvB,kBAAkB;MAClB,cAAc;IAChB;EACF;;EAEA;IACE;IACA,0BAA0B;IAC1B,4BAA4B;IAC5B,wCAAwC;IACxC,uBAAuB;IACvB,kBAAkB;IAClB,cAAc;IACd;EACF","sourcesContent":[".tablecellforemployeeRoster{\r\nfont-family: \"Inter\";\r\nfont-size: 14px;\r\nfont-weight: 700;\r\nline-height: 17px;\r\nletter-spacing: 0.02em;\r\ntext-align: left;\r\ncolor: #0070E9; white-space: nowrap !important;\r\n\r\n}\r\n.EmployeeRoster{\r\n    font-family: \"Inter\";\r\nfont-size: 18px;\r\nfont-weight: 600;\r\nline-height: 22px;\r\nletter-spacing: 0.02em;\r\ntext-align: left;\r\ncolor:#0070E9\r\n\r\n}\r\n.mainFrame{\r\n    background-color: white;\r\n    height:600px;\r\n}\r\n\r\n\r\n.AddEmployerButton{\r\n    width: 100%;\r\n    max-width: 156px;\r\nheight:45px;\r\nborder-radius: 3px;\r\nfont-family: \"Inter\";\r\nfont-size: 16px !important;\r\nfont-weight: 600 !important;\r\nline-height: 19px;\r\nletter-spacing: 0.02em;\r\ntext-align: center;\r\nbackground-color: #FE602F !important;\r\ncolor:white !important;\r\ntext-transform: capitalize !important;\r\n\r\n\r\n}\r\n\r\n.jobType{\r\n    font-family: \"Inter\";\r\nfont-size: 14px !important;\r\nfont-weight: 700 !important;\r\nline-height: 17px !important;\r\nletter-spacing: 0.02em;\r\ntext-align: left;\r\n\r\n}\r\n\r\n.TableCell{\r\n    font-family: \"Inter\";\r\nfont-size: 15px !important;\r\nfont-weight: 400 !important;\r\nline-height: 17px !important;\r\nletter-spacing: 0.02em !important;\r\ntext-align: center;\r\ncolor:#375370 !important;\r\nheight: 40px !important;\r\npadding-top: 0px !important;\r\npadding-bottom: 0px !important;\r\n\r\n}\r\n\r\n.TableCell2{\r\n    font-family: \"Inter\";\r\nfont-size: 15px !important;\r\nfont-weight: 400 !important;\r\nline-height: 17px !important;\r\nletter-spacing: 0.02em !important;\r\ntext-align: center;\r\nwhite-space: nowrap !important;\r\noverflow: hidden !important;\r\ntext-overflow: ellipsis !important;\r\noverflow: hidden !important;\r\n  position: relative !important;\r\n  color:#375370 !important;\r\n}\r\n.businessmail{\r\n    overflow: hidden !important;\r\n  position: relative !important;\r\n  white-space: nowrap !important;\r\n  text-overflow: ellipsis !important;\r\n  display: inline-block !important; \r\ntext-overflow: ellipsis !important;\r\n/* width: calc(50%); */\r\n\r\n}\r\n\r\n@media only screen and (max-width: 1400px) {\r\n    .employeeRosterMediaQuery {\r\n      width: 73vw !important;\r\n      /* border: 1px solid black !important; */\r\n      justify-content: center;\r\n      text-align: center;\r\n      padding: 0.5vw;\r\n    }\r\n  }\r\n  \r\n  @media only screen and (min-width: 1400px) {\r\n    .employeeRosterMediaQuery {\r\n    min-width: 80vw !important;\r\n    /* width: 20vw !important; */\r\n    /* border: 1px solid black !important; */\r\n    justify-content: center;\r\n    text-align: center;\r\n    padding: 0.5vw;\r\n    }\r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
